"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

// Must render <html> + <body> because it replaces the root layout. It cannot
// initialise PostHog itself: a client component can only get env via
// build-time `NEXT_PUBLIC_*` inlining, which this deploy host doesn't do
// (ADR-0002). It captures against the singleton the root layout's provider
// already loaded — so an error thrown before that provider mounts goes
// unreported, which was already true before the dead init block was removed.
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // No `environment` property on purpose. Reading it here meant
    // NEXT_PUBLIC_APP_ENV (never inlined on this host) falling through to
    // NODE_ENV, which the build fixes to "production" — so a staging crash
    // reported itself as production. The singleton already carries the correct
    // value as a super-property, and an explicit property would overwrite it.
    posthog.captureException(error, {
      digest: error.digest,
      surface: "global_error",
    });
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ padding: 24, textAlign: "center" }}>
          <h1>Något gick fel.</h1>
          <p>Vi har loggat felet. Ladda om sidan.</p>
        </div>
      </body>
    </html>
  );
}
